import { UserIcon, UsersThreeIcon } from '../../icons/lingodaIcons';

type LingodaClassType = 'individual' | 'group' | 'oc_individual' | 'oc_group' | 'trial';

interface Props {
    size?: number;
    type: LingodaClassType;
    color?: string;
}

export const LingodaClassIcon = ({ type, color, size = 24 }: Props) => {
    switch (type) {
        case 'individual':
        case 'oc_individual':
        case 'trial':
            return <UserIcon size={size} color={color} />;
        case 'group':
        case 'oc_group':
            return <UsersThreeIcon size={size} color={color} />;
    }
};
